export const downloaderFunct = (link: string, name: string, type?:string) => {
    const downloader = document.createElement('a');
    downloader.href = link;
    downloader.download = name;
    downloader.target = type === 'multiple' ? '_blank' : '_self';
    downloader.rel = "noopener"
    document.body.appendChild(downloader)
    downloader.click()
    document.body.removeChild(downloader)
};